<template>
  <table class="table item-table" :class="type">
    <thead>
    <tr>
      <th class="text-left">商品名</th>
      <th>{{col1.title}}</th>
      <th>{{col2.title}}</th>
      <th>
        <template v-if="isHideInput">
          <md-button @click="isHideInput=false">{{col3.title}}を表示する</md-button>
        </template>
        <template v-else>
          {{col3.title}}
        </template>
      </th>
    </tr>
    </thead>
    <tbody>
    <ItemTableRow
      v-for="item in visibleItems"
      :item=item
      :key=item.itemId
      :isDisplay=true
      :isHiddenItem=false
      :isHideInput=isHideInput
      :col1=col1
      :col2=col2
      :col3=col3
      @setQuantity=setQuantity
    />
    <ItemTableRow
      v-for="item in invisibleItems"
      :item=item
      :key=item.itemId
      :isDisplay=isDisplayItem
      :isHiddenItem=true
      :isHideInput=isHideInput
      :col1=col1
      :col2=col2
      :col3=col3
      @setQuantity=setQuantity
    />
    </tbody>
  </table>
</template>


<script>
  import ItemTableRow from '@/components/parts/ItemTableRow';
  import ItemTableCol from '@/models/ItemTableCol';

  export default {
    name: 'ItemTable',
    components: {
      ItemTableRow,
    },
    props: {
      visibleItems: {},
      invisibleItems: {},
      isHideCol: Boolean,
      isDisplayItem: Boolean,
      col1: ItemTableCol,
      col2: ItemTableCol,
      col3: ItemTableCol,
      type: String,
    },
    data() {
      return {
        isHideInput: this.isHideCol,
      };
    },
    methods: {
      setQuantity(type, itemId, quantity) {
        this.$emit('setQuantity', type, itemId, quantity);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .item-table {
    margin-bottom: 1rem;
    border-bottom: 1px solid #333333;

    &.delivery {
      > thead {
        > tr {
          background: #FEF2C8;
        }
      }
    }

    &.count {
      > thead {
        > tr {
          background: #FDEAEA;
        }
      }
    }

    > thead {
      > tr {
        > th {
          min-width: 88px;
          height: 65px;
          vertical-align: middle;

          &:nth-of-type(1) {
            width: 30%;
          }

          &:nth-of-type(2) {
            width: 14%;
          }

          &:nth-of-type(3),
          &:nth-of-type(4) {
            width: 28%;
          }

          button {
            font-weight: bold;
            margin: 0;
          }
        }
      }
    }

    > tbody {
      > tr {
        > td {
          border-top-color: #333333;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/parts/ItemTable.vue?77a879d7